export const STUDENT_NOTES_NOTEROWUPDATE = 'STUDENT_NOTES_NOTEROWUPDATE';

export const STUDENT_NOTES_GET_NOTES = 'STUDENT_NOTES_GET_NOTES';
export const STUDENT_NOTES_GET_NOTES_ERROR = 'STUDENT_NOTES_GET_NOTES_ERROR';

export const STUDENT_NOTES_SAVE_NOTES = 'STUDENT_NOTES_SAVE_NOTES';
export const STUDENT_NOTES_SAVE_NOTES_ERROR = 'STUDENT_NOTES_SAVE_NOTES_ERROR';

export const STUDENT_NOTES_DELETE_NOTES = 'STUDENT_NOTES_DELETE_NOTES';
export const STUDENT_NOTES_DELETE_NOTES_ERROR =
  'STUDENT_NOTES_DELETE_NOTES_ERROR';

export const STUDENT_NOTES_UPDATENOTES = 'STUDENT_NOTES_UPDATENOTES';



// WEBPACK FOOTER //
// ./src/common/Components/StudentNoteModal/state/types.js